import React from 'react';
import { InfoBoxTitle, InfoBoxWrapper } from '../Styled';
import { Content, ContentItem } from './Styled';
import { sum } from 'lodash';
import { formatCurrency } from '../../../../utils/format';
import { Divider } from '@mui/material';

interface SummaryProps {
    data: any[];
    materials?: any[];
    orderState?: string;
}

const Summary = ({ data = [], materials = [], orderState = 'Open' }: SummaryProps) => {
    const allItems = [...data, ...materials];
    
    const getItemPrice = (item: any) => {
        if (item.item_type === 'material') {
            return item.material_price || 0;
        }
        return item.product_price || 0;
    };

    const discountPrice = sum(
        allItems.map(
            (item) =>
                Math.ceil((getItemPrice(item) * (100 - (item.discount ? item.discount : 0))) / 100) *
                (item.selectedQuantity || 0)
        )
    );

    const markupPrice = sum(
        allItems.map(
            (item) =>
                Math.ceil((getItemPrice(item) * (100 + (item.markup ? item.markup : 0))) / 100) *
                (item.selectedQuantity || 0)
        )
    );

    const finalPrice = sum(
        allItems.map((item) =>
            Math.ceil(
                getItemPrice(item) *
                    ((100 - (item.discount ? item.discount : 0)) / 100) *
                    ((100 + (item.markup ? item.markup : 0)) / 100) *
                    (item.selectedQuantity || 0)
            )
        )
    );

    const totalPrice = sum(allItems.map((item: any) => getItemPrice(item) * (item.selectedQuantity || 0)));

    const amountDiscount = totalPrice - discountPrice;
    const amountMarkup = markupPrice - totalPrice;

    const productCount = data.length;
    const materialCount = materials.length;
    const totalCount = productCount + materialCount;
    
    const isOpenState = orderState === 'Open';

    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Tổng đơn hàng</InfoBoxTitle>
            <Content>
                <ContentItem>Giá ({productCount} sản phẩm, {materialCount} vật tư)</ContentItem>
                <ContentItem>{formatCurrency(totalPrice)}</ContentItem>
            </Content>
            
            {!isOpenState && (
                <>
                    <Content>
                        <ContentItem>Chiết khấu</ContentItem>
                        <ContentItem>- {formatCurrency(amountDiscount)}</ContentItem>
                    </Content>
                    <Content>
                        <ContentItem>Thuế suất</ContentItem>
                        <ContentItem>+ {formatCurrency(amountMarkup)}</ContentItem>
                    </Content>
                </>
            )}
            
            <Divider />
            <Content>
                <ContentItem style={{ fontWeight: '700' }}>Tổng đơn hàng</ContentItem>
                <ContentItem style={{ fontWeight: '700' }}>{formatCurrency(isOpenState ? totalPrice : finalPrice)}</ContentItem>
            </Content>
        </InfoBoxWrapper>
    );
};

export default Summary;
